export default __webpack_public_path__ + "static/media/user_data.95f15ee1.svg";